import React from 'react';
import { Flex, Box, Text, Image, Show, Hide } from "@chakra-ui/react";

const ImageSection = () => (
  <Flex
    mt="40px"
    direction="column"
    align="center"
    justify="center"
    width="100%"
    px={{ base: "20px", sm: "35px", md: "40px", lg: "60px", xl: "60px", "2xl": "12%" }}
  >
    {/* Mobile View */}
    <Show below="lg">
    <Box textAlign="left" maxW="90%" mb="20px" ml="0px" mr="auto" px="0">
      <Text fontSize={{ base: "24px", md: "32px", lg: "48px" }} fontWeight="600" lineHeight={{ base: "30px", md: "62.4px" }} color="white">
        <span style={{ color: '#white' }}>Create </span>
        AI Images
      </Text>
      <Text fontSize={{ base: "24px", md: "32px", lg: "48px" }} fontWeight="600" lineHeight={{ base: "30px", md: "62.4px" }} color="white">
        on Demand!
      </Text>
    </Box>


      <Flex align="center" mt="10px" justify="center">
        <Image
          src="AvatarImagehome.png"
          alt="A digital emoji of a smiling male face with light skin tone, short brown hair, and blue eyes, set against a light blue background."
          width="78px"
          height="78px"
          flexShrink="0"
          borderRadius="9px"
          background="var(--avatar-male-eric-yates-emoji, url(AvatarImage.png) lightgray 50% / cover no-repeat)"
        />
        <Box ml="10px">
          <Text fontSize="16px" fontWeight="600" lineHeight="22.4px" color="#FFF">
            “Show me <span style={{ color: '#712EFF' }}>Ellie</span> in a <span style={{ color: '#FB00C0' }}>Space Suit</span> posing on <span style={{ color: '#FF7D4E' }}>Mars</span>”
          </Text>
        </Box>
      </Flex>
      <Flex mt="10px" gap="10px" flexWrap="wrap" justify="center">
        <Box
          display="flex"
          height="27px"
          padding="8px 16px"
          justifyContent="center"
          alignItems="center"
          gap="8px"
          borderRadius="32px"
          border="2px solid #374151"
          color="#712EFF"
          fontWeight="semibold"
        >
          Ellie
        </Box>
        <Box
          display="flex"
          height="27px"
          padding="8px 16px"
          justifyContent="center"
          alignItems="center"
          gap="8px"
          borderRadius="32px"
          border="2px solid #374151"
          color="#FB00C0"
          fontWeight="semibold"
        >
          Space Suit
        </Box>
        <Box
          display="flex"
          height="27px"
          padding="8px 16px"
          justifyContent="center"
          alignItems="center"
          gap="8px"
          borderRadius="32px"
          border="2px solid #374151"
          color="#FF7D4E"
          fontWeight="semibold"
        >
          Mars
        </Box>
      </Flex>
      <Box
        position="relative"
        display="flex"
        justifyContent="center"
        alignItems="center"
        width="90%"
        mt="20px"
      >
        <Image
          src="/homepageellie.webp"
          alt="Two images of a woman astronaut. The left image shows her facing forward in a beige and white spacesuit with a desert landscape behind. The right image shows her from the back, turning her head to the right, revealing the American flag on her sleeve."
           width="100%"
            height="100%"
          position="relative"
          zIndex="1"
          mx="10px"
        />
      </Box>
    </Show>

    {/* Desktop View */}
    <Hide below="lg">
      <Flex
        direction={{ base: "column", lg: "row" }}
        align="center"
        justify="center"
        width="100%"
        p="20px"
      >
        <Box
          position="relative"
          display="flex"
          justifyContent="center"
          alignItems="center"
          width={{ base: "100%", lg: "50%" }}
          mb={{ base: "20px", lg: "0" }} // Adjust margin for better spacing
        >
          <Image
    src="/homepageellie.webp"
    alt="Two images of a woman astronaut. The left image shows her facing forward in a beige and white spacesuit with a desert landscape behind. The right image shows her from the back, turning her head to the right, revealing the American flag on her sleeve."
    width="70%"
    height="70%"
    objectFit="contain"
    position="relative"
    zIndex="1"
    mx="10px"
  />
        </Box>

        <Box
          textAlign={{ base: "left", lg: "left" }}
          maxW={{ base: "90%", lg: "50%" }}
          mt={{ base: "20px", lg: "0" }}
          zIndex="2"
        >
          <Text fontSize={{ base: "24px", md: "32px", lg: "48px" }} fontWeight="600" lineHeight={{ base: "30px", md: "62.4px" }} color="white">
            <span style={{ color: '#white' }}>Create </span>
            AI Images
          </Text>
          <Text fontSize={{ base: "24px", md: "32px", lg: "48px" }} fontWeight="600" lineHeight={{ base: "30px", md: "62.4px" }} color="white">
            on Demand!
          </Text>
          <Flex align="center" mt="10px" justify={{ base: "center", lg: "flex-start" }}>
            <Image
              src="AvatarImagehome.png"
              alt="Avatar"
              width="78px"
              height="78px"
              flexShrink="0"
              borderRadius="9px"
              background="var(--avatar-male-eric-yates-emoji, url(AvatarImage.png) lightgray 50% / cover no-repeat)"
            />
            <Box ml="10px">
              <Text fontSize="16px" fontWeight="600" lineHeight="22.4px" color="#FFF">
              “Show me <span style={{ color: '#712EFF' }}>Ellie</span> in a <span style={{ color: '#FB00C0' }}>Space Suit</span> posing on <span style={{ color: '#FF7D4E' }}>Mars</span>”
              </Text>
            </Box>
          </Flex>
          <Flex mt="10px" gap="10px" flexWrap="wrap" justify={{ base: "center", lg: "flex-start" }}>
            <Box
              display="flex"
              height="27px"
              padding="8px 16px"
              justifyContent="center"
              alignItems="center"
              gap="8px"
              borderRadius="32px"
              border="2px solid #374151"
              color="#712EFF"
              fontWeight="semibold"
            >
              Ellie
            </Box>
            <Box
              display="flex"
              height="27px"
              padding="8px 16px"
              justifyContent="center"
              alignItems="center"
              gap="8px"
              borderRadius="32px"
              border="2px solid #374151"
              color="#FB00C0"
              fontWeight="semibold"
            >
              Space Suit
            </Box>
            <Box
              display="flex"
              height="27px"
              padding="8px 16px"
              justifyContent="center"
              alignItems="center"
              gap="8px"
              borderRadius="32px"
              border="2px solid #374151"
              color="#FF7D4E"
              fontWeight="semibold"
            >
              Mars
            </Box>
          </Flex>
        </Box>
      </Flex>
    </Hide>
  </Flex>
);

export default ImageSection;
